// import React from "react";
// import {
//   FaMapMarkerAlt,
//   FaEnvelope,
//   FaPhoneAlt,
//   FaGlobe,
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
// } from "react-icons/fa";
// import { SiX } from "react-icons/si";
// import { Link } from "react-router-dom";

// import DownloadAppleApp from "../assets/images/downloadAppleApp.png";
// import DownloadAndroidApp from "../assets/images/downloadAndroidApp.png";

// const Footer = () => {
//   return (
//     <div className="bg-[#0e2d3e] text-white py-10 border-t border-white/10">
//       <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
//         {/* Column 1 */}
//         <div>
//           <h4 className="text-xl font-bold mb-4">ParkAJV</h4>
//           <p className="mb-4">
//             Empowering cities through smart parking solutions—efficient space
//             utilization, real-time monitoring, and seamless management for a
//             smoother urban commute.
//           </p>
//           <div className="flex -ml-2">
//             <img
//               src={DownloadAppleApp}
//               alt="App Store"
//               className="w-32 object-contain"
//             />
//             <img
//               src={DownloadAndroidApp}
//               alt="Play Store"
//               className="w-32 object-contain"
//             />
//           </div>
//         </div>

//         {/* Column 2 */}
//         <div>
//           <h4 className="text-xl font-bold mb-4">Products</h4>
//           <ul className="space-y-2">
//             <li>
//               <Link to="/door-to-door-collection">MLCP</Link>
//             </li>
//             <li>
//               <Link to="/weighbridge">OFF-Street</Link>
//             </li>
//             <li>
//               <Link to="/bin-monitoring">ON-Street</Link>
//             </li>
//             {/* <li>
//               <Link to="/vehicle-monitoring">Vehicle Monitoring</Link>
//             </li>
//             <li>
//               <Link to="/employee-management">Employee</Link>
//             </li>
//             <li>
//               <Link to="/ai-waste-management">AI Waste</Link>
//             </li> */}
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div>
//           <h4 className="text-xl font-bold mb-4">Quick Links</h4>
//           <ul className="space-y-2">
//             <li>
//               <Link to="/blogs">Blog</Link>
//             </li>
//             <li>
//               <Link to="/videos">Video</Link>
//             </li>
//             <li>
//               <Link to="/gallery">Gallery</Link>
//             </li>
//             <li>
//               <Link to="/brochure">Brochure</Link>
//             </li>
//             <li>
//               <Link to="/datasheet">DataSheet</Link>
//             </li>
//             <li>
//               <Link to="/privacypolicy">Privacy Policy</Link>
//             </li>
//             <li>
//               <Link to="/termofuse">Terms & Conditions</Link>
//             </li>
//           </ul>
//         </div>

//         {/* Column 4 */}
//         <div>
//           <h4 className="text-xl font-bold mb-4">Useful Links</h4>
//           <ul className="space-y-2">
//             <li>
//               <a
//                 href="https://swachhbharatmission.ddws.gov.in/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Swachh Bharat Mission
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://smartcity.ndmc.gov.in/content/projects/project-details/smart-parking"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 NDMC
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://gmda.gov.in/?language=en"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 GMDA
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://environment.delhi.gov.in/environment/waste-management"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Delhi Smart Waste
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://www.psa.gov.in/waste-to-wealth"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Waste to Wealth
//               </a>
//             </li>
//           </ul>
//         </div>

//         {/* Column 5 */}
//         <div>
//           <h4 className="text-xl font-bold mb-4">Contact Info</h4>
//           <div className="space-y-3">
//             <p className="flex items-start gap-3">
//               <FaMapMarkerAlt className="mt-1 text-[#00D084]" fontSize={30} />
//               505, Tower A-1, Corporate Park, Noida-201301, Uttar Pradesh, India
//             </p>
//             <p className="flex items-center gap-3">
//               <FaEnvelope className="text-[#00D084]" />
//               presales@ajeevi.com
//             </p>
//             <p className="flex items-center gap-3">
//               <FaPhoneAlt className="text-[#00D084]" />
//               +91-9654323500
//             </p>
//             <p className="flex items-center gap-3">
//               <FaGlobe className="text-[#00D084]" />
//               <a
//                 href="https://ajeevi.com/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 https://ajeevi.com/
//               </a>
//             </p>
//           </div>
//           <div className="flex items-center gap-3 mt-4">
//             <a
//               href="https://www.facebook.com/ajeevidigitaal"
//               className="bg-[#00D084] p-2 rounded-full"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaFacebookF />
//             </a>
//             <a
//               href="https://x.com/ajeevidigital"
//               className="bg-[#00D084] p-2 rounded-full"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <SiX />
//             </a>
//             <a
//               href="https://www.instagram.com/ajeevidigital"
//               className="bg-[#00D084] p-2 rounded-full"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaInstagram />
//             </a>
//             <a
//               href="https://in.linkedin.com/company/ajeevi-tech"
//               className="bg-[#00D084] p-2 rounded-full"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaLinkedinIn />
//             </a>
//           </div>
//         </div>
//       </div>

//       <div className="text-center mt-10 border-t border-white/10 pt-4 text-sm">
//         <p>
//           ©{" "}
//           <a
//             href="https://ajeevi.com/"
//             className="underline"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Ajeevi
//           </a>
//           , All right reserved. Designed by{" "}
//           <a
//             href="https://ajeevi.com/"
//             className="underline"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Ajeevi
//           </a>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Footer;



import React from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaGlobe,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { SiX } from "react-icons/si";
import { Link } from "react-router-dom";

import DownloadAppleApp from "../assets/images/downloadAppleApp.png";
import DownloadAndroidApp from "../assets/images/downloadAndroidApp.png";

const Footer = () => {
  return (
    <div className="bg-[#0e2d3e] text-white py-10 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Column 1 */}
        <div>
          <h4 className="text-xl font-bold mb-4">GyanYantram</h4>
          <p className="mb-4">
            Empowering education through digital innovation—interactive learning tools, smart technology integration, and accessible knowledge for a brighter future.

          </p>
          <div className="flex -ml-2">
            <Link to="/shop" state={{ category: "Mobile Application" }}>
              <img
                src={DownloadAppleApp}
                alt="App Store"
                className="w-32 object-contain"
              />
            </Link>
            <Link to="/shop" state={{ category: "Mobile Application" }}>
              <img
                src={DownloadAndroidApp}
                alt="Play Store"
                className="w-32 object-contain"
              />
            </Link>
          </div>
        </div>

        {/* Column 2 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Products</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/gyan-yantram">GyanYantram</Link>
            </li>
            <li>
              <Link to="/vmd">VMD</Link>
            </li>
            <li>
              <Link to="/ecb">ECB</Link>
            </li>
            <li>
              <Link to="/pas">PAS</Link>
            </li>
            <li>
              <Link to="/cctv-camera">Camera</Link>
            </li>
            <li>
              <Link to="/wifi-router">Wi-Fi</Link>
            </li>
            <li>
              <Link to="/environmental-sensor">Environmental Sensor</Link>
            </li>
             <li>
              <Link to="/flood-sensor">Flood Sensor</Link>
            </li>
             <li>
              <Link to="/temperature-sensor">Temperature Sensor</Link>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/blogs">Blog</Link>
            </li>
            <li>
              <Link to="/videos">Video</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/brochure">Brochure</Link>
            </li>
            <li>
              <Link to="/datasheet">DataSheet</Link>
            </li>
            <li>
              <Link to="/privacypolicy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/termofuse">Terms & Conditions</Link>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Useful Links</h4>
          <ul className="space-y-2">
            <li>
              <a
                href="https://smartcities.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Smart Cities Mission – MoHUA
              </a>
            </li>
            <li>
              <a
                href="https://niti.gov.in/planning/smart-city-initiatives"
                target="_blank"
                rel="noopener noreferrer"
              >
                NITI Aayog – Smart City Initiatives
              </a>
            </li>
            <li>
              <a
                href="https://www.bis.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                BIS – IoT & Smart Infrastructure Standards
              </a>
            </li>
            <li>
              <a
                href="https://www.digitalindia.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Digital India – Urban Innovation
              </a>
            </li>
            <li>
              <a
                href="https://cdnbbsr.s3waas.gov.in/s3d1957b0075a6c9f6fb1d4f539d8fe6f1/uploads/2022/08/2022081872.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bhuvan GyanYantram Pilot (ISRO)
              </a>
            </li>
          </ul>
        </div>

        {/* Column 5 */}
        <div>
          <h4 className="text-xl font-bold mb-4">Contact Info</h4>
          <div className="space-y-3">
            <p className="flex items-start gap-3">
              <FaMapMarkerAlt className="mt-1 text-[#00D084]" fontSize={30} />
              505, Tower A-1, Corporate Park, Noida-201301, Uttar Pradesh, India
            </p>
            <p className="flex items-center gap-3">
              <FaEnvelope className="text-[#00D084]" />
              presales@ajeevi.com
            </p>
            <p className="flex items-center gap-3">
              <FaPhoneAlt className="text-[#00D084]" />
              +91-9654323500
            </p>
            <p className="flex items-center gap-3">
              <FaGlobe className="text-[#00D084]" />
              <a
                href="https://ajeevi.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ajeevi.com/
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3 mt-4">
            <a
              href="https://www.facebook.com/ajeevidigitaal"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/ajeevidigital"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiX />
            </a>
            <a
              href="https://www.instagram.com/ajeevidigital"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://in.linkedin.com/company/ajeevi-tech"
              className="bg-[#00D084] p-2 rounded-full"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mt-10 border-t border-white/10 pt-4 text-sm">
        <p>
          ©{" "}
          <a
            href="https://ajeevi.com/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ajeevi
          </a>
          , All right reserved. Designed by{" "}
          <a
            href="https://ajeevi.com/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ajeevi
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;

